import WIDGETS from './widgets';

export default {
	name: 'sidebar_left_user_navigation',
	sx: {
		height: '100%',
		flexWrap: 'nowrap',
	},
	spacing: 0,
	direction: 'column',
	widgets: [{ content: WIDGETS.SIDE_BAR_LEFT_USER_NAVIGATION, breakpoints: { xs: 12 }, lazy_loading: 0 }],
};
